import { type PropsWithChildren } from "react";
import { trackingContext } from "./context";
import type { TrackingContext } from "./types";

export function TrackingContextProvider({
  children,
  ...context
}: PropsWithChildren<TrackingContext>) {
  return (
    <trackingContext.Provider value={context}>
      {children}
    </trackingContext.Provider>
  );
}
